import type { MetaAppSettings } from '@rp/contracts'
import { Button } from '../../design'
import { formatDateTime } from '../../lib/time'
import { CopyField } from './CopyField'
import { META_APP_COPY } from './copy'

type MetaAppDetailsProps = {
  settings: MetaAppSettings
  onReplaceSecret: () => void
  onReplaceApp: () => void
}

export const MetaAppDetails = ({ settings, onReplaceSecret, onReplaceApp }: MetaAppDetailsProps) => (
  <div className="meta-app-details">
    <dl className="settings-readonly">
      <dt>{META_APP_COPY.appId}</dt>
      <dd className="num">{settings.appId}</dd>
    </dl>
    <p className="settings-hint measure">{META_APP_COPY.secretSetAt(formatDateTime(new Date(settings.secretUpdatedAt)))}</p>
    <CopyField label={META_APP_COPY.webhookUrl} hint={META_APP_COPY.webhookUrlHint} value={settings.webhookUrl} />
    <CopyField label={META_APP_COPY.verifyToken} hint={META_APP_COPY.verifyTokenHint} value={settings.verifyToken} />
    {settings.verifyTokenReissued ? (
      <p className="settings-error text-tone tone-warning" role="status">
        {META_APP_COPY.verifyTokenReissued}
      </p>
    ) : null}
    <CopyField
      label={META_APP_COPY.oauthRedirectUri}
      hint={META_APP_COPY.oauthRedirectUriHint}
      value={settings.oauthRedirectUri}
    />
    <div className="settings-save">
      <Button onClick={onReplaceSecret}>{META_APP_COPY.replaceSecret}</Button>
      <Button onClick={onReplaceApp}>{META_APP_COPY.replaceApp}</Button>
    </div>
  </div>
)
